export default __webpack_public_path__ + "static/media/inline5.e5b47687.jpg";